import { useMemo } from "react";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import { Organization } from "shared/components/organisms/OrganizationsToChoose/Organization";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";
import useWindowSize from "shared/utils/hooks/useWindowSize";

export const MainOrganizationCard = () => {
  const {
    state: { tenancy, theme },
  } = useGlobalContext();

  const generalTheme = tenancy?.settings?.["general-theme"];
  const platformName = tenancy?.settings?.site?.siteName;

  const windowSize = useWindowSize();
  const isMobile = windowSize.width < 850;
  const plataformIcon = useMemo(
    () => ({
      dark: generalTheme?.themeDarkModeLogoIcon,
      light: generalTheme?.themeLogoIcon,
    }),
    [theme?.value, isMobile],
  );

  return (
    <ComponentErrorBoundary>
      <Organization
        org={
          {
            id: 0,
            title: platformName,
            description: "Esta é a organização principal.",
            main_image: plataformIcon?.[theme?.value],
            fallbackBackgroundColor:
              theme?.value === "dark"
                ? generalTheme?.themeDarkModeMasterColor
                : generalTheme?.themeMasterColor,
          } as any
        }
      />
    </ComponentErrorBoundary>
  );
};
